import { ConfigDomain } from './config.types';

export const DOMAIN_LABELS: Record<ConfigDomain, string> = {
  ADQUIRENCIA: 'Adquirência',
  DELIVERY: 'Delivery',
  FINANCEIRO: 'Financeiro',
  FISCAL: 'Fiscal',
  IMPRESSAO: 'Impressão',
  PDV: 'Pdv',
  RELATORIO: 'Relatórios',
};

export function getDomainLabel(domain: ConfigDomain): string {
  return DOMAIN_LABELS[domain] ?? domain;
}
